/**
 *  RS Compare Table
 *  JavaScript functionality for the comparison table section
 */

class RSCompareTable {
  constructor() {
    this.init();
  }

  init() {
    // Initialize any functionality needed for the comparison table
    this.setupMobileScrollIndicators();
    this.setupResponsiveLayout();
  }

  setupMobileScrollIndicators() {
    // Add scroll indicators for mobile view when table is wider than viewport
    const tables = document.querySelectorAll('.rs-compare-table__wrapper');
    
    tables.forEach(tableWrapper => {
      // Check if table is wider than its container
      const checkOverflow = () => {
        if (tableWrapper.scrollWidth > tableWrapper.clientWidth) {
          tableWrapper.classList.add('has-overflow');
          // Only show indicators if not scrolled all the way
          this.updateScrollIndicators(tableWrapper);
        } else {
          tableWrapper.classList.remove('has-overflow');
        }
      };

      // Update scroll indicators when scrolling
      tableWrapper.addEventListener('scroll', () => {
        this.updateScrollIndicators(tableWrapper);
      });

      // Check on load and resize
      checkOverflow();
      window.addEventListener('resize', checkOverflow);
    });
  }

  updateScrollIndicators(tableWrapper) {
    // Show/hide left/right scroll indicators based on scroll position
    const scrollLeft = tableWrapper.scrollLeft;
    const maxScroll = tableWrapper.scrollWidth - tableWrapper.clientWidth;
    
    // Near left edge
    if (scrollLeft < 10) {
      tableWrapper.classList.remove('scroll-left');
    } else {
      tableWrapper.classList.add('scroll-left');
    }
    
    // Near right edge
    if (maxScroll - scrollLeft < 10) {
      tableWrapper.classList.remove('scroll-right');
    } else {
      tableWrapper.classList.add('scroll-right');
    }
  }

  setupResponsiveLayout() {
    // Handle any responsive layout adjustments
    const updateLayout = () => {
      const tables = document.querySelectorAll('.rs-compare-table__table');
      
      tables.forEach(table => {
        // Apply different classes based on viewport width
        if (window.innerWidth < 768) {
          table.classList.add('mobile-view');
        } else {
          table.classList.remove('mobile-view');
        }
      });
    };
    
    // Run on load and resize
    updateLayout();
    window.addEventListener('resize', updateLayout);
  }
}

// Initialize when DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new RSCompareTable();
});

// Re-initialize for Shopify theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('section-rs-compare-table')) {
    new RSCompareTable();
  }
});
